export default "__VITE_ASSET__Djz_nrvR__"